import { Button } from '@platform/components';
import LinkedInLogo from './LinkedIn_icon.svg';

export const LinkedInSignInButton = () => {
  const logInHref = import.meta.env.VITE_API_HOST + '/login/linkedin';

  return (
    <Button href={logInHref} variant='secondary-gray' size='lg' additionalClassnames='w-full'>
      <img src={LinkedInLogo} height='24' width='24' /> {'Log in with LinkedIn'}
    </Button>
  );
};
